<template lang="html">
  <si-container :back="back">
    <v-flex
      xs12
      md4
    >
      <v-card>
        <v-card-title
          class="hedline"
          style="min-width:280px"
        >
          Template Details
        </v-card-title>
        <v-card-text class="pt-4">
          <v-layout wrap>
            <v-flex xs12>
              <SiInputTextarea
                v-model="template.description"
                outlined
                label="Template description"
                hide-detailsx
                auto-grow
                rows="2"
                @change="setSaveRequired(template.id)"
              />
            </v-flex>
            <v-flex xs12>
              <SiInputText
                v-model="template.mjid"
                outlined
                label="Mailjet id"
                hide-detailsx
                auto-grow
                rows="2"
                :rules="[_ruleRequired()]"
                @change="setSaveRequired(template.id)"
              />
            </v-flex>
            <v-scale-transition>
              <v-flex
                v-if="changeRequired"
                xs12
                py-2
                text-center
                class="grey lighten-2"
              >
                <v-btn
                  color="error"
                  class="mx-1 my-2"
                  @click="save"
                >
                  <v-icon left>
                    publish
                  </v-icon> Commit changes
                </v-btn>
                <v-btn
                  color="grey"
                  text
                  @click="cancelChanges"
                >
                  Cancel Changes
                </v-btn>
              </v-flex>
            </v-scale-transition>
            <v-flex
              xs12
              text-center
            >
              <SiDeleteButton
                title="Delete Template?"
                :message="`Are you certain you want to delete <strong>${template.id}</strong>? If this template is still in use it will cause emails that use this template to fail.`"
                :challenge="template.id"
                @delete="deleteTemplate(template.id)"
              >
                <template #activator="{ on }">
                  <v-btn
                    text
                    color="grey"
                    v-on="on"
                  >
                    Delete template
                  </v-btn>
                </template>
              </SiDeleteButton>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex
      xs12
      md8
    >
      <v-card>
        <v-card-title
          class="hedline"
          style="min-width:280px"
        >
          Mandatory template fields
        </v-card-title>
        <v-simple-table>
          <tbody>
            <tr
              v-for="item in vars"
              :key="item.id"
            >
              <td
                class="py-2 font-weight-medium"
                width="10"
              >
                {{ item.id }}:
              </td>
              <td class="py-2">
                <SiInputText
                  v-model="template.vars[item.id]"
                  outlined
                  single-line
                  hide-details
                  label="default value"
                  @change="setSaveRequired(template.id)"
                />
              </td>
              <td
                width="10"
                class="pl-0"
              >
                <v-btn
                  text
                  icon
                  color="grey"
                  small
                  @click="removeVariable(item.id)"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-card-text>
          <SiVariableEditor
            variable-term="variable_name"
            :existing-variables="template.vars"
            class="mt-3"
            @variable="newVariable"
          />
        </v-card-text>
      </v-card>
    </v-flex>
  </si-container>
</template>

<script>
import { cloneDeep } from 'lodash'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import validations from '@/mixins/validations'

export default {
  mixins: [ helpers, validations ],
  props: {
    value: Object,
    back: String
  },
  data () {
    return {
      template: cloneDeep(this.value),
      baseTemplate: cloneDeep(this.value)
    }
  },
  computed: {
    // ...mapGetters([]),
    changeRequired () {
      return JSON.stringify(this.template) !== JSON.stringify(this.baseTemplate)
    },
    vars () {
      if (!this.template.vars) return []
      return Object.keys(this.template.vars).map(k => { return { id: k, default: this.template.vars[k] } })
    }
  },
  watch: {
    value: {
      handler (v) {
        this.template = cloneDeep(v),
        this.baseTemplate = cloneDeep(v)
      },
      immediate: true
    }
  },
  methods: {
    setSaveRequired () {

    },
    cancelChanges () {
      this.template = cloneDeep(this.baseTemplate)
    },
    save () {
      rtdb.ref(`templates/${this.template.id}`).set(this._removeUndefined(this.template))
      this.baseTemplate = cloneDeep(this.template)
    },
    newVariable (name) {
      if (!this.template.vars) this.$set(this.template, 'vars', {})
      this.$set(this.template.vars, name, '')
    },
    removeVariable (name) {
      this.$delete(this.template.vars, name)
    },
    deleteTemplate () {
      rtdb.ref(`templates/${this.template.id}`).set(null)
    }
  }
}
</script>

<style lang="css" scoped>

</style>
